import { useCallback, useEffect, useState } from 'react'
import {
  EMPTY_INTEGRATION_CHAT_GLOBAL_UNREAD,
  fetchIntegrationChatGlobalUnread,
  type IntegrationChatUnreadByIntegrationId,
} from '@/components/common/IntegrationChatDock/integrationChatGlobalUnread'

type UseCrmIntegrationTabsUnreadCountsParams = {
  enabled?: boolean
}

type UseCrmIntegrationTabsUnreadCountsResult = {
  unreadByIntegrationId: IntegrationChatUnreadByIntegrationId
  refetchUnread: () => void
}

/** GET unread-count → counts по integration_id для бейджей на табах ботов/сообществ. */
export const useCrmIntegrationTabsUnreadCounts = ({
  enabled = true,
}: UseCrmIntegrationTabsUnreadCountsParams = {}): UseCrmIntegrationTabsUnreadCountsResult => {
  const [unreadByIntegrationId, setUnreadByIntegrationId] =
    useState<IntegrationChatUnreadByIntegrationId>(
      EMPTY_INTEGRATION_CHAT_GLOBAL_UNREAD.byIntegrationId,
    )

  const refetchUnread = useCallback(() => {
    if (!enabled) {
      return
    }

    void (async () => {
      const snapshot = await fetchIntegrationChatGlobalUnread()
      if (snapshot == null) {
        return
      }

      setUnreadByIntegrationId(snapshot.byIntegrationId)
    })()
  }, [enabled])

  useEffect(() => {
    if (!enabled) {
      setUnreadByIntegrationId(
        EMPTY_INTEGRATION_CHAT_GLOBAL_UNREAD.byIntegrationId,
      )
      return
    }

    refetchUnread()
  }, [enabled, refetchUnread])

  return { unreadByIntegrationId, refetchUnread }
}
